import support from '../../services/support';
import messageDialog from '../../components/message-dialog.vue'
import MapaParceiros from './mapa-parceiros.vue'
import Account from '../../services/account';

const subject = [{
    value: '1',
    valueId: '8',
    caption: 'Auto Peças'
  },
  {
    value: '2',
    valueId: '8',
    caption: 'Centro Automotivo'
  },
  {
    value: '3',
    valueId: '8',
    caption: 'Comércio de Pneus'
  },
  {
    value: '4',
    valueId: '8',
    caption: 'Concessionária de Veículos'
  },
  {
    value: '5',
    valueId: '8',
    caption: 'Corretora de Seguros'
  },
  {
    value: '6',
    valueId: '8',
    caption: 'Pátio de Veículos'
  },
  {
    value: '7',
    valueId: '8',
    caption: 'Reparo de Parabrisas'
  },
  {
    value: '8',
    valueId: '8',
    caption: 'Revenda de Veículos'
  },
  {
    value: '9',
    valueId: '8',
    caption: 'Vistoria Veícular'
  },
  {
    value: '10',
    valueId: '8',
    caption: 'Outros'
  },
];

export default {
  data() {
    return {
      faleConosco:{},
      formState: 'NEW',
      errorMessage: '',
      subject,
      subjects: '1',
      loading: undefined,
      cep: undefined,
      listaConveniados: [],
      listaMapa: [],
      endereco: undefined,
      conveniado: undefined,
    }
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {
    cep(){
      if(this.cep == null || this.cep == ""){
        this.endereco = null;
        this.listaConveniados = [];
        this.listaMapa = [];
      }
    }
  },
  methods: {
    doRequest() {
      this.formState = 'NEW';
      this.$validator.validateAll()
        .then(success => {
          this.faleConosco.assunto = subject.find(s => s.value == this.faleConosco.assuntoId).caption;
          this.faleConosco.assuntoId = subject.find(s => s.value == this.faleConosco.assuntoId).valueId;
          this.loading = support.faleConosco(this.faleConosco)
            .then(data => {
              if (data) this.formState = 'SUCCESS';
            })
            .catch(err => {
              this.formState = 'ERROR';
              this.errorMessage = err.data && err.data.status && err.data.status.message || "Ocorreu um erro, por favor tente novamente";
            });
        });

    },
    buscaParceiros(){
      if(this.cep && this.cep != ""){
        this.endereco = this.cep;
      }else{
        messageDialog.show({
          title: 'Aviso',
          message: 'Por favor digite um número de CEP válido!',
          headerClass: 'modal-info'
        });
      }
      
    },
    addMapa(conveniado){
      if(conveniado.latitude && conveniado.longitude){
        let end = _.find(this.listaMapa, function(l){
          return l.nomeFantasia == conveniado.nomeFantasia;
        });
        if(!end){
          this.conveniado = conveniado;
        }
        
      }else{
        messageDialog.show({
          title: 'Aviso',
          message: 'Parceiro não possui as coordenadas cadastradas',
          headerClass: 'modal-info'
        });
      }
      
    },
    listaProximos(lat,lng){
      var req = {
        lat: lat,
        lng: lng
      }
      Account.buscaConveniadosProximos(req).then(res => {
        var lista = res.lista;
        this.listaConveniados = [];
        this.listaMapa = [];
        if(lista.length > 0){
          _.each(lista, obj => {
            if(obj.distancia < 1)
              obj.distancia = String(obj.distancia).substr(0,4);
            else
              obj.distancia = Math.round(obj.distancia);
            this.listaConveniados.push(obj);
          });
        //
        }else {
          messageDialog.show({
            title: 'Aviso',
            message: 'Não existem parceiros próximos no raio de 100km!',
            headerClass: 'modal-info'
          });
        }
      });
    },
    mapeados(mapa){
      this.listaMapa = _.filter(this.listaMapa, function(l){
        return l.marcador != mapa.marcador;
      });
      this.listaMapa.push(mapa);
    }
  },
  components: {
    MapaParceiros
  }
}



// WEBPACK FOOTER //
// ./src/pages/external/contact-partner.js